// ConciergeFilterContext.tsx
import React, { createContext, useReducer, useContext } from "react";
import { Action, initialState, State } from "./types";
import { ConciergeFilterReducer } from "./conciergeFilterReducer";


interface ContextProps {
    state: State;
    dispatch: React.Dispatch<Action>;
}

const ConciergeFilterContext = createContext<ContextProps | undefined>(undefined);

export const ConciergeFilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(ConciergeFilterReducer, initialState);

    return (
        <ConciergeFilterContext.Provider value={{ state, dispatch }}>
            {children}
        </ConciergeFilterContext.Provider>
    );
};

export const useConciergeFilter = (): ContextProps => {
    const context = useContext(ConciergeFilterContext);
    if (!context) {
        throw new Error("useConciergeFilter must be used within a ConciergeFilterProvider");
    }
    return context;
};
